// extracted by mini-css-extract-plugin
export var active = "_fj-2";
export var recordingDot = "_fj-1";
export var recordingIndicator = "_fj-0";